import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Register from "./components/Register";
import Login from "./components/Login";
import Home from "./components/Home";
import UseCases from "./components/UseCases";
import UseCaseDetail from "./components/UseCaseDetail";
import Enquiry from "./components/Enquiry";
import VendorRejectionAgent from "./components/VendorRejectionAgent";
import SupplyChainAgent from "./components/SupplyChainAgent";
import AutomatedQuotationAgent from "./components/AutomatedQuotationAgent";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import AivioChat from "./components/chat/AivioChat";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Privacy from "./components/PrivacyPolicy";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import KnowYourCost from "./components/KnowYourCost";
import NotFound from "./components/NotFound";
import { ScrollProgress, useSiteMotion } from "./motion";
import useCases from "./data/useCases";

function AppContent({ token, setToken }) {
  const location = useLocation();
  // Standalone demo pages with their own embedded chat; routes match case-insensitively, so compare in lowercase.
  const hideLayout = ["/enquiry", "/vendorrejectionagent", "/supplychainagent", "/automatedquotationagent"].includes(location.pathname.toLowerCase().replace(/\/+$/, ""));
  useSiteMotion(location.pathname);

  useEffect(() => {
    const path = location.pathname.toLowerCase().replace(/\/+$/, "") || "/";
    const useCase = useCases.find((item) => path === `/use-cases/${item.slug}`);
    const titles = { "/use-cases": "Use cases", "/know-your-cost": "Estimate your cost", "/login": "Log in", "/register": "Get started", "/privacy-policy": "Privacy policy" };
    const known = ["/", "/invoice", "/enquiry", "/vendorrejectionagent", "/supplychainagent", "/automatedquotationagent"].includes(path);
    const page = useCase ? useCase.title : titles[path] || (path.startsWith("/use-cases/") ? "Use case not found" : known ? null : "Page not found");
    document.title = page ? `${page} | Aivio` : "Aivio | Enterprise AI agents";
  }, [location.pathname]);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    // Wait for the new route to render before scrolling to the requested section.
    const timer = window.setTimeout(() => {
      document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <div>
      {!hideLayout && <ScrollProgress />}
      {!hideLayout && <Nav setToken={setToken} />}

      <div key={location.pathname} className="route-transition">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/use-cases/:slug" element={<UseCaseDetail />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/know-your-cost" element={<KnowYourCost />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/vendorrejectionagent" element={<VendorRejectionAgent />} />
        <Route path="/supplychainagent" element={<SupplyChainAgent />} />
        <Route path="/automatedquotationagent" element={<AutomatedQuotationAgent />} />
        <Route path="/invoice" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />

      </Routes>
      </div>

      {!hideLayout && <Footer />}
      {!hideLayout && <AivioChat />}
    </div>
  );
}

function App() {
  const [token, setToken] = useState(sessionStorage.getItem("token"));

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken !== token) {
      setToken(storedToken);
    }
  }, [token]);

  return (
    <Router>
      <AppContent token={token} setToken={setToken} />
    </Router>
  );
}

export default App;
